/* import __COLOCATED_TEMPLATE__ from './error.hbs'; */
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
let MagicLinkErrorComponent = (_dec = service('ember-multipass-logging'), _dec2 = service('ember-multipass-storage'), _dec3 = service('ember-multipass-tracking'), _dec4 = service('ember-multipassfe-client'), _class = class MagicLinkErrorComponent extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "logger", _descriptor, this);
    _initializerDefineProperty(this, "storage", _descriptor2, this);
    _initializerDefineProperty(this, "tracking", _descriptor3, this);
    _initializerDefineProperty(this, "multipassfeClient", _descriptor4, this);
    this.logger.addComponentBreadcrumb('MagicLinkErrorComponent');
    this.tracking.trackPageView({
      pageTitle: 'Risk Magic Link Error'
    });
  }
  get tPrefix() {
    return this.args.tPrefix || '';
  }
  get supportUrl() {
    return this.multipassfeClient.constants.SUPPORT_URL;
  }
  handleLoginLinkClick(event) {
    const target = event.target;
    if (target.tagName === 'MARKET-LINK') {
      event.preventDefault();
      this.backToSignIn('Link');
    }
  }
  backToSignIn(elementType = 'Button') {
    this.tracking.trackButtonClick({
      elementIdentifier: 'Back to Sign In (from Risk Magic Link Error)',
      elementType
    });
    this.storage.clearRiskMagicLinkSent();
    this.multipassfeClient.redirectToUrl('/logout');
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "logger", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "storage", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "tracking", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "multipassfeClient", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "handleLoginLinkClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleLoginLinkClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "backToSignIn", [action], Object.getOwnPropertyDescriptor(_class.prototype, "backToSignIn"), _class.prototype), _class);
export { MagicLinkErrorComponent as default };